<fm-pendo [accountUserPermission]="pendoConfiguration$ | async">
</fm-pendo>
